<script setup lang="ts">
import {Head, useForm} from "@inertiajs/vue3";
import Layout from "@/Pages/auth/layouts/AuthLayout.vue";
import FormCard from "@/Pages/auth/components/FormCard.vue";
import {ref} from "vue";

defineOptions({layout: Layout})
const form = useForm({})

const status = ref()

const submit = () => {
    form.post(route('verification.send'), {
        onSuccess: () => {
            status.value = 'A new verification link has been sent to the email address you provided during registration.'
        },
    })
}
</script>

<template>
    <Head title="Verify your email address" />
    <form-card
        :status="status"
        :loading="form.processing"
        error-messages="Before proceeding, please check your email inbox for a verification link."
        @submit="submit"
    >
        <template #title>
            Please verify your email address
        </template>
        <p>We sent you an email with a link to verify your email address. Click the link in the email to continue.</p>
        <template #submit>
            Resend verification email
        </template>
    </form-card>
</template>

<style scoped>

</style>
